<template>
  <div class="dropPathContainer" :class="{isLast: isLast}">
      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 264.564 264.564" style="enable-background:new 0 0 264.564 264.564;"
        xml:space="preserve" class="dropPath">
      <g>
        <g>
          <path  :class="{'no': !done, 'yes': done}" d="M132.281,264.564c51.24,0,92.931-41.681,92.931-92.918c0-50.18-87.094-164.069-90.803-168.891L132.281,0l-2.128,2.773
            c-3.704,4.813-90.802,118.71-90.802,168.882C39.352,222.883,81.042,264.564,132.281,264.564z"/>
        </g>
      </g>
      </svg>
      <i class="fa stepIcon" aria-hidden="true" :class="iconClass"></i>
      <div class="tick" v-if="done" >&#10004;</div>
      <div class="close" v-if="!done">&#10008;</div>
  </div>
</template>

<script>
  export default {
    props: {
      done: {
         type: Boolean,
         default: false,
      },
      isLast: {
         type: Boolean,
         default: false,
      },
      iconClass:{
        type: String,
        default: 'fa-cubes'
      }
    }
  }
</script>

<style lang="scss" scoped>
   .dropPath{
      transform: rotate(180deg);
      .no{
        fill: red;
      }
      .yes{
        fill: rgb(27, 219, 84);
      }
   }
   
   .dropPathContainer{
     width: 50px;
     position: absolute;
     top: -60px;
     left: -35px;
     &.isLast{
       right: -35px;
       left: auto;

     }
     &:hover div{
       opacity: 1;
       transform: translate(-50%, 0);
     }
     svg{
       width: 100%;
     }
     div{
       position: absolute;
       top:-20px;
       left: 50%;
       transform: translate(-50%, 20px);
       color: #fff;
       z-index: 2;
       opacity: 1;
       font-size: 18px;
       font-weight: normal;
       opacity: 0;
       
       transition: all 300ms ease-in;
     }
     div.tick{
       color: rgb(27, 219, 84);
       top: -25px;
     }
     div.close{
       color: red;
     }
     .stepIcon{
       position: absolute;
       top:12px;
       left: 50%;
       transform: translate(-50%, 0);
       color: #fff;
       z-index: 2;
       opacity: 1;
       font-size: 15px;
       font-weight: normal;
     }
   }

</style>